import * as Autocomplete from './css/Autocomplete.css';

import * as Option from './components/Option/Option.css';
import * as Group from './components/Group/Group.css';
import * as MobileDropdown from './components/MobileDropdown/MobileDropdown.css';
import * as DirectionsDialog from './components/DirectionsDialog/DirectionsDialog.css';
import * as LocationOptionsList from './components/LocationOptionsList/LocationOptionsList.css';

export default {
	Autocomplete,
	Option,
	Group,
	MobileDropdown,
	DirectionsDialog,
	LocationOptionsList
};
